export function clamp (number: number, min: number, max: number): number {
  return number > max ? max : (number < min ? min : number);
}
